import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SelectedItem } from 'src/app/controls/models/selected-item.interface';

@Pipe({
  name: 'competitor',
  standalone: true,
})
export class CompetitorPipe implements PipeTransform {
  transform(
    value: SelectedItem[],
    formGroup: FormGroup,
    controlName: string,
    updated: Date
  ): SelectedItem[] {
    if (!value || !value.length || !formGroup || !controlName || !updated) {
      return value;
    }

    const values: number[] = [];
    ['driverId', 'navigatorId', 'additionalCompetitors'].forEach((key) => {
      if (key !== controlName) {
        if (key === 'additionalCompetitors') {
          const additionalCompetitors: number[] = formGroup.get(key).value;
          additionalCompetitors?.forEach((competitor) => {
            values.push(competitor);
          })
        }
        values.push(formGroup.get(key).value);
      }
    });

    return value.filter((item) => !values.includes(item.value));
  }
}
